export default {"src":"/_next/static/media/research_rider_journal.721f1cbd.svg","height":284,"width":284};